import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton, CircularProgress } from "@mui/material";
import OtpMobileIcon from "../../../assets/Images/OtpMobileIcon 1.png";
import LoginSubmitWhiteIcon from "../../../assets/Icons/RegisterLoginIconOrange.png";
import styles from "../../../css/OtpModal.module.css";
import "../../../css/Login.css";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";

const SingleOtpModal = ({ show, handleClose, bagData, onSubmit, data }) => {
  const [senderOtp, setSenderOtp] = useState(["", "", "", "", "", ""]);
  const [timeLeft, setTimeLeft] = useState(60);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let timer;
    if (show && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [show, timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = (seconds % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleInputChange = (index, value, type) => {
    if (!/^\d*$/.test(value)) return;
    const newValues = [...senderOtp];
    newValues[index] = value;
    setSenderOtp(newValues);

    if (value && index < newValues.length - 1) {
      const nextInput = document.getElementById(
        `${type}-otp-input-${index + 1}`
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    if (/^\d{6}$/.test(pastedData)) {
      const digits = pastedData.split("");
      setSenderOtp(digits);
    }
  };

  const handleKeyDown = (e, index, type) => {
    const otpArray = senderOtp;
    if (e.key === "Backspace" && !otpArray[index] && index > 0) {
      const prevInput = document.getElementById(
        `${type}-otp-input-${index - 1}`
      );
      if (prevInput) prevInput.focus();
    }
  };

  const handleSubmit = () => {
    const sender = senderOtp.join("");
    if (sender.length !== 6) {
      alert("OTPs must be 6 digits");
      return;
    }
    setLoading(true);
    setTimeout(() => {
      onSubmit({ sender, bagData });
      setLoading(false);
      handleClose();
      setSenderOtp(["", "", "", "", "", ""]);
    }, 1000);
  };

  if (!show) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalBox}>
        <div className={styles.modalHeader}>
          <IconButton onClick={handleClose} size="small" className="z-20">
            <CloseIcon />
          </IconButton>
        </div>

        {/* Background Images */}
        <img
          src={LeftCircle}
          alt="leftImg"
          className="absolute left-0 bottom-0 w-[110px] h-[105px]"
        />
        <img
          src={RightCircle}
          alt="leftImg"
          className="absolute right-0 top-0 w-[110px] h-[105px]"
        />

        <div className={styles.modalContent}>
          <div className={styles.iconWrapper}>
            <img src={OtpMobileIcon} alt="OTP Verification" />
          </div>

          {/* Sender OTP */}
          <div className="mb-6">
            <p className={styles.instruction}>
              Please enter the 6 digit code sent to you at
              <br />
              <span>{data?.maskedMobile}</span>
            </p>
            <div className={styles.otpInputContainer}>
              {senderOtp.map((val, i) => (
                <input
                  key={i}
                  id={`sender-otp-input-${i}`}
                  type="text"
                  maxLength={1}
                  value={val}
                  onChange={(e) =>
                    handleInputChange(i, e.target.value, "sender")
                  }
                  onKeyDown={(e) => handleKeyDown(e, i, "sender")}
                  onPaste={i === 0 ? handlePaste : undefined}
                  className={styles.otpInput}
                  autoComplete="off"
                />
              ))}
            </div>
          </div>

          <div className="login-btn-container">
            <div onClick={handleSubmit} className="btn loginNow-btn">
              {loading ? (
                <CircularProgress style={{ width: "20px", height: "20px" }} />
              ) : (
                <span className="login-text">Submit</span>
              )}
            </div>

            <span onClick={handleSubmit} className="login-icon">
              <img
                src={LoginSubmitWhiteIcon}
                alt="Submit"
                className="w-[50px]"
              />
            </span>
          </div>

          <div className={styles.resendContainer}>
            {timeLeft > 0 ? (
              <div className={styles.resendText}>
                OTP expire in <strong>{formatTime(timeLeft)}</strong>
              </div>
            ) : (
              <button
                onClick={() => {
                  setSenderOtp(["", "", "", "", "", ""]);
                  setTimeLeft(60);
                }}
                disabled={loading}
                className="text-[#ff702b] font-bold"
              >
                Resend OTP
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleOtpModal;
